//Smooth scroll START
$(function() {
	$('a[href*="#"]:not([href="#"])').click(function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top
			}, 200);
		return false;
		}
	}
	});
});
//Smooth scroll END

//Waypoints START
function waypoints() {
	$('.waypoint').each(function() {
		var thisOne = $(this);

		var waypoint = new Waypoint({
			element: thisOne,
			handler: function(direction) {
				if(direction == 'down'){
					
					if(thisOne.parents('section').is(':first-child')){
						thisOne.addClass('animate');
					}else{
						setTimeout(function(){
							thisOne.addClass('animate');
						}, 200);
					}
				}
			},
			offset: '90%',
		});

		var waypoint = new Waypoint({
			element: thisOne,
			handler: function(direction) {
				if(direction == 'up'){
					thisOne.removeClass('animate');
				}
			},
			offset: '100%'
		});
	});
}
//Waypoints END

//Waypoint.refreshAll();

//Scroll Menu START
var body = document.body;
var triggerMenu = document.querySelector(".page-header .trigger-menu");
var nav = document.querySelector(".page-header nav");
var menu = document.querySelector(".page-header .menu");
var scrollUp = "scroll-up";
var scrollDown = "scroll-down";
let lastScroll = 0;

window.addEventListener("scroll", function(e) {
  var currentScroll = window.pageYOffset;
  if (currentScroll < 50) {
	body.classList.remove(scrollUp);
	return;
  }

  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
	// down
	body.classList.remove(scrollUp);
	body.classList.add(scrollDown);
  } else if (currentScroll < lastScroll && currentScroll < 50 && body.classList.contains(scrollDown)) {
	// up and at top
	body.classList.remove(scrollDown);
	body.classList.remove(scrollUp);
	
  } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
	// up
	body.classList.remove(scrollDown);
	body.classList.add(scrollUp);
  }
  lastScroll = currentScroll;
});
//Scroll Menu END

//console.log(myTheme);

$(window).ready(function() {
	//$('.pakery-grid').addClass('loading');

	$('#burger').click(function(){
		$(this).toggleClass('open');
		$(this).addClass('close');
		$('html').toggleClass('menu-open');
	});

	$('li.menu-item-has-children').click(function(){
		$(this).toggleClass('open');
	});

	$('.main-menu li a').click(function(e){
		e.stopPropagation()
		// $('#burger').toggleClass('open');
		// $('#burger').addClass('close');
		// $('html').toggleClass('menu-open');
	});

	$('p:has(img)').css('margin-bottom','0').addClass('p-img');
	$('p:has(.btn)').css('margin-bottom','0').addClass('btn-con');

	$('p.btn-con').each(function(){
		var thisOne = this;
		var thisBtn = $(this);

		var textA = thisOne.style.textAlign;

		if(textA == 'center'){
			thisBtn.addClass('btn-con-center');
		} else if(textA == 'right') {
			thisBtn.addClass('btn-con-right');
		} else if(textA == 'left') {
			thisBtn.addClass('btn-con-left');
		}
	})

	if ($('dl.accordion').length > 0) {
		
		$(document).on('click', 'dl.accordion dt', function(){
			var thisOne = $(this);
			thisOne.parent('dl.accordion').find('dt').next('dd').css('maxHeight', '0px');
			thisOne.parent('dl.accordion').find('dt').removeClass('open');
			var ddH = thisOne.next('dd').find('.inner').outerHeight();
			thisOne.next('dd').css('maxHeight', ddH+'px');
			thisOne.addClass('open');
	
			setTimeout(function(){
				Waypoint.refreshAll();
			}, 500);
		});
	
		$(document).on('click', 'dl.accordion dt.open', function(){
			var thisOne = $(this);
			thisOne.parent('dl.accordion').find('dt').removeClass('open');
			thisOne.parent('dl.accordion').find('dt').next('dd').css('maxHeight', '0px');
			thisOne.removeClass('open');
			
			setTimeout(function(){
				Waypoint.refreshAll();
			}, 500);
		});
	
		$(window).resize(function() {
			$('dl.accordion dt.open').each(function(){
				var thisOne = $(this);
				var ddH = thisOne.next('dd').find('.inner').outerHeight();
				thisOne.next('dd').css('maxHeight', ddH+'px');
			});
		});
	}

	jQuery(document).bind('gform_post_render', function(){
		$('.ginput_container_fileupload').append('<span class="file-name"></span>');
		$('[type="file"]').wrap('<div class="file-con"></div>');
	});

	$(document).on('change', '[type="file"]', function(){
		var thisOne = $(this);
		var fileName = thisOne.prop('files')[0];

		if(fileName === undefined){
			thisOne.parents('.ginput_container_fileupload').find('.file-name').text('').removeClass('file');
		} else {
			var fileName = thisOne.prop('files')[0]['name'];
			thisOne.parents('.ginput_container_fileupload').find('.file-name').text(fileName).addClass('file');
		}
	});

	if ($('.menu-text-con').length > 0) {
		$('.menu-text-con').each(function() {
			var $thisOne = $(this);
			$('.main-menu > li.menu-item-has-children > .sub-menu').prepend($thisOne);
		});
	}

	if ($('#menu-image-431').length > 0 && $('#menu-item-431 > .sub-menu').length > 0) {
		$('#menu-item-431 > .sub-menu').append($('#menu-image-431'));
	}

	if ($('#menu-image-432').length > 0 && $('#menu-item-432 > .sub-menu').length > 0) {
		$('#menu-item-432 > .sub-menu').append($('#menu-image-432'));
	}

	if ($('#menu-image-433').length > 0 && $('#menu-item-433 > .sub-menu').length > 0) {
		$('#menu-item-433 > .sub-menu').append($('#menu-image-433'));
	}

	if ($('#menu-image-434').length > 0 && $('#menu-item-434 > .sub-menu').length > 0) {
		$('#menu-item-434 > .sub-menu').append($('#menu-image-434'));
	}

	if ($('#menu-image-522').length > 0 && $('#menu-item-658 > .sub-menu').length > 0) {
		$('#menu-item-658 > .sub-menu').append($('#menu-image-522'));
	}

	$('.main-menu > .menu-item').each(function(){
		var thisOne = $(this);
		thisOne.find('.sub-menu').find('.menu-item').wrapAll('<span class="menu-items"></span>')
	});

	$('#bookADemo').on('click', function(){
		$('#bookADemoPopUp').addClass('open');
	});

	$('.pop-up .close').on('click', function(){
		$('.pop-up').removeClass('open');
	});

	$('.search-btn').on('click', function(){
		$('.search').addClass('open');

		setTimeout(function(){
			$('.facetwp-search').focus()
		}, 250);
	});

	$('.search .close').on('click', function(){
		$('.search').removeClass('open');
	});

	

//	//people select
//	$('.people-con .on-change').on('change', function() {
//		$('.name-side .names, .bio-side .bio-con').removeClass('active');
//
//		var activeSelect = $(this).val();
//		$(".bio-side .bio-con#"+activeSelect).addClass('active');
//		$(".name-side .names[rel='"+activeSelect+"']").addClass("active");
//	});
});

$(window).on('load', function(){
	$('html').addClass('loaded');

	setTimeout(function(){
		$(window).trigger('resize');

		setTimeout(function(){
			$(window).trigger('resize');
			waypoints();
		}, 0);
	}, 0);

	$(document).on('focus', '.main-wrapper section .ginput_container input:not([type="checkbox"]):not([type="radio"]), .main-wrapper section .ginput_container textarea, .pop .ginput_container input:not([type="checkbox"]):not([type="radio"]), .pop .ginput_container textarea', function() {
		$(this).closest('.gfield').addClass('has-focus');
	});
	
	$(document).on('blur', '.main-wrapper section .ginput_container input:not([type="checkbox"]):not([type="radio"]), .main-wrapper section .ginput_container textarea, .pop .ginput_container input:not([type="checkbox"]):not([type="radio"]), .pop .ginput_container textarea', function() {
		const $field = $(this).closest('.gfield');
		if ($(this).val().trim() === '') {
			$field.removeClass('has-focus');
		}
	});

	function initFocusStates() {
		$('.main-wrapper section .ginput_container input:not([type="checkbox"]):not([type="radio"]), .main-wrapper section .ginput_container textarea, .pop .ginput_container input:not([type="checkbox"]):not([type="radio"]), .pop .ginput_container textarea').each(function() {
			if ($(this).val().trim() !== '') {
				$(this).closest('.gfield').addClass('has-focus');
			}
		});
	}

	  


	  // On page load
	$(document).ready(function() {
		initFocusStates();
	});
  
	// After Gravity Forms AJAX render (GF adds this event)
	$(document).on('gform_post_render', function() {
		initFocusStates();
	});



	$('.breadcrumbs > span > span:first-of-type > a').prepend('<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.92448 0.102539L11.0807 4.47754C11.276 4.65332 11.2956 4.94629 11.1393 5.1416C10.9635 5.33691 10.6706 5.35645 10.4753 5.2002L10.0065 4.79004V8.42285C10.0065 9.30176 9.30339 9.98535 8.44401 9.98535H2.81901C1.9401 9.98535 1.25651 9.30176 1.25651 8.42285V4.79004L0.768229 5.2002C0.572917 5.35645 0.279948 5.33691 0.104167 5.1416C-0.0520833 4.94629 -0.0325521 4.65332 0.16276 4.47754L5.31901 0.102539C5.49479 -0.0341797 5.7487 -0.0341797 5.92448 0.102539ZM2.19401 8.42285C2.19401 8.77441 2.46745 9.04785 2.81901 9.04785H3.75651V6.0791C3.75651 5.64941 4.08854 5.29785 4.53776 5.29785H6.72526C7.15495 5.29785 7.50651 5.64941 7.50651 6.0791V9.04785H8.44401C8.77604 9.04785 9.06901 8.77441 9.06901 8.42285V3.98926L5.63151 1.0791L2.19401 3.98926V8.42285ZM4.69401 9.04785H6.56901V6.23535H4.69401V9.04785Z" fill="#002F60"/></svg>');




	// const swiper = new Swiper('.-slide', {
	// 	loop: true,
	// 	spaceBetween: 0,
	// 	slidesPerView: 1,
	// 	preventInteractionOnTransition: true,
	// 	autoplay: {
	// 		delay: 3000,
	//		disableOnInteraction: false,
	//		pauseOnMouseEnter: true,
	// 	},
	// 	speed: 300,
	// 	navigation: {
	// 		nextEl: '.swiper-button-next',
	// 		prevEl: '.swiper-button-prev',
	// 	},
	// 	pagination: {
	// 		el: '.swiper-pagination',
	// 		type: 'bullets',
	// 		clickable: true,
	// 	},
	// 	scrollbar: {
	// 		el: '.swiper-scrollbar',
	// 		draggable: true,
	// 		hide: false,
	// 	},
	// 	breakpoints: {
	// 		768: {
	// 			spaceBetween: 0,
	// 			slidesPerView: 3,
	// 		},
	// 		1100: {
	// 			spaceBetween: 0,
	// 			slidesPerView: 4,
	// 		}
	// 	}
	// });

	const swiperL = new Swiper('.logo-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 1.8,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		speed: 3000,
		breakpoints: {
			769: {
				spaceBetween: 0,
				slidesPerView: 5.94,
			},
		}
	});

	const swiperA = new Swiper('.affiliated-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 1.8,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		speed: 3000,
		breakpoints: {
			769: {
				spaceBetween: 0,
				slidesPerView: 5,
			},
		}
	});

	const swiperQ = new Swiper('.quote-slide', {
		loop: false,
		spaceBetween: 0,
		slidesPerView: 1,
		autoplay: {
			delay: 7000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		speed: 300,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'custom',
			renderCustom: function (swiper, current, total) {
				if (current < 10) {
					current = '0'+current;
				}

				if (total < 10) {
					total = '0'+total;
				}
				return '<span>' + current + '</span> ' + '<span class="spacer"></span>' + '<span>' + total + '</span>';
			},
		},
	});

	const swiperNN = new Swiper('.news-nav-slide', {
		loop: false,
		spaceBetween: 0,
		slidesPerView: 1,
		preventInteractionOnTransition: true,
		// autoplay: {
		// 	delay: 0,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		speed: 410,
		watchSlidesProgress: true,
		breakpoints: {
			769: {
				spaceBetween: 0,
				slidesPerView: 'auto',
			},
		}
	});

	const swiperN = new Swiper('.news-slide', {
		loop: false,
		spaceBetween: 0,
		slidesPerView: 1,
		preventInteractionOnTransition: true,
		// autoplay: {
		// 	delay: 0,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		speed: 410,
		thumbs:{
			swiper: swiperNN,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'custom',
			renderCustom: function (swiper, current, total) {
				if (current < 10) {
					current = '0'+current;
				}

				if (total < 10) {
					total = '0'+total;
				}
				return '<span>' + current + '</span> ' + '<span class="spacer"></span>' + '<span>' + total + '</span>';
			},
		},
	});

	// child and parent slides
	// swiperQ.controller.control = swiperQI;  
	// swiperQI.controller.control = swiperQ;

	$('.swiper-wrapper').each(function(){
		$(this).parents('.swiper').css('overflow', 'visible');
		$(this).wrap('<div class="swiper-wrapper-con" style="overflow: hidden;"></div>');
	});

	$('.i-item .icon-con').matchHeight({ property: 'min-height' });
	$('.i-item .inner').matchHeight({ property: 'min-height' });

	$('.g-item .text').matchHeight({ property: 'min-height' });
	$('.g-item .inner').matchHeight({ property: 'min-height' });

	$('.text-area').fitVids();

	document.addEventListener('facetwp-loaded', function(event){

		setTimeout(function(){
			$(window).trigger('resize');
			waypoints();
			//ScrollTrigger.refresh();
		}, 0);

		const count = FWP.settings.pager.total_rows;
		const resultCountElement = document.querySelector('.facetwp-results-count');
		
		if (resultCountElement) {
			resultCountElement.innerHTML = count + ' results for News & Insights';
		}

		const resultCountElementSearch = document.querySelector('.facetwp-results-count-search');
		
		if (resultCountElementSearch) {
			const urlParams = new URLSearchParams(window.location.search);
			const searchSkillgate = urlParams.get('_search_skillgate');

			if (searchSkillgate == null) {
				resultCountElementSearch.innerHTML = count + ' results for <strong>"'+searchSkillgate+'"</strong>';
				$('.facetwp-results-count-search').addClass('hide');
			} else {
				$('.facetwp-results-count-search').removeClass('hide');
				resultCountElementSearch.innerHTML = count + ' results for <strong>"'+searchSkillgate+'"</strong>';
			}
		}
		
	});

});

(function( $ ) {

	/**
	 * initMap
	 *
	 * Renders a Google Map onto the selected jQuery element
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @return  object The map instance.
	 */
	function initMap( $el ) {

		var stylers = [
			{
				"featureType": "all",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#e563c3"
					}
				]
			},
			{
				"featureType": "all",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#ffecf0"
					}
				]
			},
			{
				"featureType": "all",
				"elementType": "labels.text",
				"stylers": [
					{
						"color": "#b0315a"
					}
				]
			},
			// {
			// 	"featureType": "all",
			// 	"elementType": "labels.text.fill",
			// 	"stylers": [
			// 		{
			// 			"gamma": 0.01
			// 		},
			// 		{
			// 			"lightness": 20
			// 		}
			// 	]
			// },
			{
				"featureType": "all",
				"elementType": "labels.text.stroke",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "all",
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#f7cfe0"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "geometry",
				"stylers": [
					{
						"lightness": 0
					},
					{
						"saturation": 0
					},
					{
						"color": "#cecece"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "all",
				"stylers": [
					{
						"lightness": -10
					}
				]
			}
		]

		// Find marker elements within map.
		var $markers = $el.find('.marker');

		// Create gerenic map.
		var mapArgs = {
			//styles		: stylers,
			mapTypeControl: false,
			//draggable: false,
			scaleControl: false,
			scrollwheel: false,
			fullscreenControl: false,
			navigationControl: false,
			streetViewControl: false,
			zoom        : $el.data('zoom') || 16,
			mapTypeId   : google.maps.MapTypeId.ROADMAP
		};
		var map = new google.maps.Map( $el[0], mapArgs );

		// Add markers.
		map.markers = [];
		$markers.each(function(){
			initMarker( $(this), map );
		});

		// Center map based on markers.
		centerMap( map );

		// Return map instance.
		return map;
	}

	/**
	 * initMarker
	 *
	 * Creates a marker for the given jQuery element and map.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @param   object The map instance.
	 * @return  object The marker instance.
	 */
	function initMarker( $marker, map ) {

		// Get position from marker.
		var lat = $marker.data('lat');
		var lng = $marker.data('lng');
		var latLng = {
			lat: parseFloat( lat ),
			lng: parseFloat( lng )
		};

		// const icon = {
		//     url: myTheme.theme_directory+"/assets/images/marker.svg", // url
		//     scaledSize: new google.maps.Size(60, 72), // scaled size
		//     origin: new google.maps.Point(0,0), // origin
		//     anchor: new google.maps.Point(30, 72) // anchor
		// };

		// Create marker instance.
		var marker = new google.maps.Marker({
			position : latLng,
			//icon: icon,
			map: map
		});

		// Append to reference for later use.
		map.markers.push( marker );

		// If marker contains HTML, add it to an infoWindow.
		if( $marker.html() ){

			// Create info window.
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html()
			});

			// Show info window when marker is clicked.
			google.maps.event.addListener(marker, 'click', function() {
				infowindow.open( map, marker );
			});
		}
	}

	/**
	 * centerMap
	 *
	 * Centers the map showing all markers in view.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   object The map instance.
	 * @return  void
	 */
	function centerMap( map ) {

		// Create map boundaries from all map markers.
		var bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function( marker ){
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
		});

		// Case: Single marker.
		if( map.markers.length == 1 ){
			map.setCenter( bounds.getCenter() );

		// Case: Multiple markers.
		} else{
			map.fitBounds( bounds );
		}
	}

	$('.acf-map').each(function(){
		var map = initMap( $(this) );
	});

})(jQuery);